import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export type SupportLoginResult =
  | { ok: true }
  | { ok: false; message?: string; feedbackShown?: boolean };

@Component({
  selector: 'gep-support-login',
  imports: [ReactiveFormsModule],
  templateUrl: './support-login.component.html',
  styleUrl: '../password-dialog/password-dialog.css',
})
export class SupportLoginComponent {
  private readonly activeModal = inject(NgbActiveModal);

  readonly nome = new FormControl('', { nonNullable: true });
  readonly senha = new FormControl('', { nonNullable: true });

  authenticate?: (nome: string, senha: string) => Promise<SupportLoginResult>;

  validationMessage = '';
  pending = false;

  cancel(): void {
    this.activeModal.dismiss();
  }

  confirmFromEnter(event: Event): void {
    event.preventDefault();
    void this.confirm();
  }

  async confirm(): Promise<void> {
    if (this.pending || !this.authenticate) {
      return;
    }

    this.pending = true;
    this.validationMessage = '';

    try {
      const result = await this.authenticate(this.nome.value, this.senha.value);
      if (result.ok) {
        this.activeModal.close();
        return;
      }

      if (!result.feedbackShown && result.message) {
        this.validationMessage = result.message;
      }
    } catch (error: unknown) {
      this.validationMessage =
        error instanceof Error ? error.message : 'Dados de login inválidos';
    } finally {
      this.pending = false;
    }
  }
}
